import Vue from "vue";
import Vuetify from "vuetify/lib/framework";

Vue.use(Vuetify);

const vuetify = new Vuetify({
  theme: {
    dark: false,
    options: {
      customProperties: true,
    },
    themes: {
      light: {
        primary: "#f87676",
        secondary: "#30384d",
        accent: "#10B981",
        error: "#EF4444",
        warning: "#F59E0B",
        info: "#3B82F6",
        success: "#10B981",
        background: "#EDF0F4",
        surface: "#FFFFFF",
      },
      dark: {
        primary: "#f87676",
        secondary: "#30384d",
        accent: "#10B981",
        error: "#EF4444",
        warning: "#F59E0B",
        info: "#3B82F6",
        success: "#10B981",
        background: "#080E1B",
        surface: "#111827",
      },
    },
  },
});

export default vuetify;
